import { useAgenciesQuery } from 'core/graphql/Agency/Agency.generated';
import { Agency } from 'core/graphql/types';

type AgenciesResult = {
  agenciesData: Agency[];
  areAgenciesLoading: boolean;
};

const useAgenciesDataStore = (): AgenciesResult => {
  const { data, loading } = useAgenciesQuery();
  if (data !== undefined) {
    return {
      agenciesData: data.Agencies,
      areAgenciesLoading: loading,
    };
  }

  return {
    agenciesData: [],
    areAgenciesLoading: false,
  };
};

export default useAgenciesDataStore;
